'use client';

import { cn } from '@/lib/utils';
import { TextareaHTMLAttributes, forwardRef } from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';
import ErrorText from './ErrorText';

interface CustomTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    required?: boolean;
    className?: string;
    register?: UseFormRegister<any>;
    error?: FieldError | string;
}

const Textarea = forwardRef<HTMLTextAreaElement, CustomTextareaProps>((props, ref) => {
    const { className, required, register, error, value, ...textareaProps } = props;

    return (
        <div className="flex flex-col relative">
            <textarea
                {...register}
                {...textareaProps}
                value={value}
                ref={ref}
                className={cn(
                    'w-full border-b border-dark-grey text-h6 font-medium text-black placeholder-dark-grey py-[10px] focus:border-brand focus:outline-none min-h-10 placeholder-shown:border-grey bg-transparent rounded-none',
                    error && 'border-red-400',
                    className,
                )}
                placeholder={required ? `${textareaProps.placeholder}*` : textareaProps.placeholder}
                required={required}
            />
            {error && <ErrorText error={error} />}
        </div>
    );
});

Textarea.displayName = 'Textarea';

export default Textarea;
